import React from 'react';

import logo from '../../images/logo.svg';
import styled from 'styled-components';

import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons';

// associacao: itens também visíveis para usuários de associação (as rotas em App.js seguem a mesma regra)
const MENU = [
    { to: '/painel', label: 'Início' },
    { to: '/home', label: 'Mapa interativo', associacao: true },
    { to: '/produtores', label: 'Fornecedores' },
    { to: '/associacoes', label: 'Associações' },
    { to: '/microrregioes', label: 'Microrregiões' },
    { to: '/custos', label: 'Custos' },
    { to: '/relatorio', label: 'Relatório', associacao: true },
    { to: '/sobre', label: 'Sobre' },
];

function MainBar({ isLogged, isADM, onLogout }) {

    const menu = isADM ? MENU : MENU.filter(item => item.associacao);

    return <SiteHeader>
        <Inner>
            <Brand>
                <img src={logo} alt="Veja Logo" />
            </Brand>

            {isLogged && <>
                <Menu>
                    {menu.map(item => (
                        <StyledNavLink key={item.to} activeClassName='is-active' to={item.to}>
                            {item.label}
                        </StyledNavLink>
                    ))}
                </Menu>

                <Actions>
                    <LogoutButton onClick={onLogout} title="Sair">
                        <FontAwesomeIcon icon={faSignOutAlt} />
                        <span>Sair</span>
                    </LogoutButton>
                    <Avatar aria-hidden="true">
                        <FontAwesomeIcon icon={faUser} />
                    </Avatar>
                </Actions>
            </>}
        </Inner>
    </SiteHeader>;
}

const SiteHeader = styled.header`
    background: var(--vft-surface);
    border-bottom: 1px solid var(--vft-border);
    margin-bottom: 20px;
`;

const Inner = styled.div`
    display: flex;
    align-items: center;
    gap: 24px;
    max-width: 1450px;
    margin: 0 auto;
    padding: 12px 24px;
`;

const Brand = styled.div`
    flex: 0 0 auto;

    & img {
        height: 44px;
        width: auto;
        display: block;
    }
`;

const Menu = styled.nav`
    flex: 1 1 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }
`;

const StyledNavLink = styled(NavLink)`
    flex: 0 0 auto;
    padding: 8px 16px;
    border-radius: 6px;
    font-family: var(--vft-font);
    font-size: 14px;
    color: var(--vft-ink);
    white-space: nowrap;
    transition: background-color .15s ease, color .15s ease;

    &:hover, &:focus {
        color: var(--vft-ink);
        background-color: var(--vft-hover);
        text-decoration: none;
    }

    &.is-active, &.is-active:hover, &.is-active:focus {
        background-color: var(--vft-ink);
        color: #fff;
        font-weight: 600;
        text-decoration: none;
    }
`;

const Actions = styled.div`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    gap: 12px;
`;

const LogoutButton = styled.button`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 7px 14px;
    border-radius: 6px;
    background-color: var(--vft-surface);
    border: 1px solid var(--vft-border-strong);
    color: var(--vft-ink);
    font-family: var(--vft-font);
    font-size: 14px;
    cursor: pointer;
    transition: background-color .15s ease;

    &:hover {
        background-color: var(--vft-hover);
    }
`;

const Avatar = styled.div`
    width: 36px;
    height: 36px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: var(--vft-hover);
    color: var(--vft-muted);
    font-size: 15px;
`;

export default MainBar;
